import Inventory from 'components/General/Dashboard/Inventory/Inventory';
import Debt from 'components/General/Dashboard/Debt/Debt';
import OrdersDashboard from './Orders/Orders';
import BudgetsDashboard from './Orders/BudgetsDashboard';
import Routes from './Routes/Routes';
import { ApiRequest } from 'GlobalFunctions';
import { useEffect, useState } from 'react';

export default function Dashboard(props: any) {
    const { setLoading } = props;

    const [modules, setModules] = useState<any>([]);

      const getPermissions = async () => {
        setLoading(true);
        await ApiRequest({
          url: "/companies/getModules",
          method: "get",
          headers: {
              ltkn: localStorage.getItem('ltkn')
          },
          setResponse: (response: any) => {
            setModules(response.modules);
          },
        });
      }


      useEffect(() => {
        getPermissions();
      }, []);

    return (
        <>
            {modules.includes(1) && <Inventory setLoading={setLoading} />}
            {modules.includes(2) && <Debt setLoading={setLoading} />}
            {modules.includes(3) && <OrdersDashboard setLoading={setLoading} />}
            {modules.includes(3) && <BudgetsDashboard setLoading={setLoading} />}
            {modules.includes(4) && <Routes setLoading={setLoading} />}
        </>
    );
}